// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__k12aW","modalContent":"Modal_modalContent__87ZKR","close":"Modal_close__ECLN2"};